import React, { Component } from 'react';
import Formulario from './SeleccionarFormPeriodo';


class SeleccionarPeriodo extends Component{

    componentDidMount = () => {
        const { listarPeriodosOtros } = this.props;
        listarPeriodosOtros();
    }
    render(){
        const { periodos_nomina } = this.props;
        return(
           
            <Formulario
                periodoL={ periodos_nomina } 
            />
           
        );
    } 
}

export default SeleccionarPeriodo;